/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GAR
 */
export interface GAR {
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  readonly uuid?: string;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  readonly gmwNitgCode?: string;
  /**
   *
   * @type {Date}
   * @memberof GAR
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof GAR
   */
  readonly updated?: Date;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  broId: string;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  deliveryAccountableParty: string | null;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  qualityRegime: string | null;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  qualityControlMethod: string | null;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  gmwBroId: string | null;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  tubeNumber: string | null;
  /**
   *
   * @type {Date}
   * @memberof GAR
   */
  samplingDatetime: Date | null;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  samplingStandard: string | null;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  primaryColour: string | null;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  secondaryColour: string | null;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  colourStrength: string | null;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  pumpType: string | null;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  abnormalityInCooling: string | null;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  abnormalityInDevice: string | null;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  pollutedByEngine: string | null;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  filterAerated: string | null;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  groundwaterLevelDroppedTooMuch: string | null;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  abnormalFilter: string | null;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  sampleAerated: string | null;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  hoseReused: string | null;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  temperatureDifficultToMeasure: string | null;
  /**
   *
   * @type {Date}
   * @memberof GAR
   */
  labAnalysisDate: Date | null;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  dataOwner: string;
  /**
   *
   * @type {string}
   * @memberof GAR
   */
  monitoringTube: string | null;
}

/**
 * Check if a given object implements the GAR interface.
 */
export function instanceOfGAR(value: object): value is GAR {
  if (
    (!("broId" in (value as Record<string, any>)) &&
      !("bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["broId"] === undefined &&
      (value as Record<string, any>)["bro_id"] === undefined)
  )
    return false;
  if (
    (!("deliveryAccountableParty" in (value as Record<string, any>)) &&
      !("delivery_accountable_party" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["deliveryAccountableParty"] === undefined &&
      (value as Record<string, any>)["delivery_accountable_party"] === undefined)
  )
    return false;
  if (
    (!("qualityRegime" in (value as Record<string, any>)) &&
      !("quality_regime" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["qualityRegime"] === undefined &&
      (value as Record<string, any>)["quality_regime"] === undefined)
  )
    return false;
  if (
    (!("qualityControlMethod" in (value as Record<string, any>)) &&
      !("quality_control_method" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["qualityControlMethod"] === undefined &&
      (value as Record<string, any>)["quality_control_method"] === undefined)
  )
    return false;
  if (
    (!("gmwBroId" in (value as Record<string, any>)) &&
      !("gmw_bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["gmwBroId"] === undefined &&
      (value as Record<string, any>)["gmw_bro_id"] === undefined)
  )
    return false;
  if (
    (!("tubeNumber" in (value as Record<string, any>)) &&
      !("tube_number" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["tubeNumber"] === undefined &&
      (value as Record<string, any>)["tube_number"] === undefined)
  )
    return false;
  if (
    (!("samplingDatetime" in (value as Record<string, any>)) &&
      !("sampling_datetime" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["samplingDatetime"] === undefined &&
      (value as Record<string, any>)["sampling_datetime"] === undefined)
  )
    return false;
  if (
    (!("samplingStandard" in (value as Record<string, any>)) &&
      !("sampling_standard" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["samplingStandard"] === undefined &&
      (value as Record<string, any>)["sampling_standard"] === undefined)
  )
    return false;
  if (
    (!("primaryColour" in (value as Record<string, any>)) &&
      !("primary_colour" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["primaryColour"] === undefined &&
      (value as Record<string, any>)["primary_colour"] === undefined)
  )
    return false;
  if (
    (!("secondaryColour" in (value as Record<string, any>)) &&
      !("secondary_colour" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["secondaryColour"] === undefined &&
      (value as Record<string, any>)["secondary_colour"] === undefined)
  )
    return false;
  if (
    (!("colourStrength" in (value as Record<string, any>)) &&
      !("colour_strength" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["colourStrength"] === undefined &&
      (value as Record<string, any>)["colour_strength"] === undefined)
  )
    return false;
  if (
    (!("pumpType" in (value as Record<string, any>)) &&
      !("pump_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["pumpType"] === undefined &&
      (value as Record<string, any>)["pump_type"] === undefined)
  )
    return false;
  if (
    (!("abnormalityInCooling" in (value as Record<string, any>)) &&
      !("abnormality_in_cooling" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["abnormalityInCooling"] === undefined &&
      (value as Record<string, any>)["abnormality_in_cooling"] === undefined)
  )
    return false;
  if (
    (!("abnormalityInDevice" in (value as Record<string, any>)) &&
      !("abnormality_in_device" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["abnormalityInDevice"] === undefined &&
      (value as Record<string, any>)["abnormality_in_device"] === undefined)
  )
    return false;
  if (
    (!("pollutedByEngine" in (value as Record<string, any>)) &&
      !("polluted_by_engine" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["pollutedByEngine"] === undefined &&
      (value as Record<string, any>)["polluted_by_engine"] === undefined)
  )
    return false;
  if (
    (!("filterAerated" in (value as Record<string, any>)) &&
      !("filter_aerated" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["filterAerated"] === undefined &&
      (value as Record<string, any>)["filter_aerated"] === undefined)
  )
    return false;
  if (
    (!("groundwaterLevelDroppedTooMuch" in (value as Record<string, any>)) &&
      !("groundwater_level_dropped_too_much" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["groundwaterLevelDroppedTooMuch"] === undefined &&
      (value as Record<string, any>)["groundwater_level_dropped_too_much"] === undefined)
  )
    return false;
  if (
    (!("abnormalFilter" in (value as Record<string, any>)) &&
      !("abnormal_filter" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["abnormalFilter"] === undefined &&
      (value as Record<string, any>)["abnormal_filter"] === undefined)
  )
    return false;
  if (
    (!("sampleAerated" in (value as Record<string, any>)) &&
      !("sample_aerated" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["sampleAerated"] === undefined &&
      (value as Record<string, any>)["sample_aerated"] === undefined)
  )
    return false;
  if (
    (!("hoseReused" in (value as Record<string, any>)) &&
      !("hose_reused" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["hoseReused"] === undefined &&
      (value as Record<string, any>)["hose_reused"] === undefined)
  )
    return false;
  if (
    (!("temperatureDifficultToMeasure" in (value as Record<string, any>)) &&
      !("temperature_difficult_to_measure" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["temperatureDifficultToMeasure"] === undefined &&
      (value as Record<string, any>)["temperature_difficult_to_measure"] === undefined)
  )
    return false;
  if (
    (!("labAnalysisDate" in (value as Record<string, any>)) &&
      !("lab_analysis_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["labAnalysisDate"] === undefined &&
      (value as Record<string, any>)["lab_analysis_date"] === undefined)
  )
    return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  if (
    (!("monitoringTube" in (value as Record<string, any>)) &&
      !("monitoring_tube" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["monitoringTube"] === undefined &&
      (value as Record<string, any>)["monitoring_tube"] === undefined)
  )
    return false;
  return true;
}

export function GARFromJSON(json: any): GAR {
  return GARFromJSONTyped(json, false);
}

export function GARFromJSONTyped(json: any, ignoreDiscriminator: boolean): GAR {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    gmwNitgCode: json["gmw_nitg_code"] == null ? undefined : json["gmw_nitg_code"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    broId: json["bro_id"],
    deliveryAccountableParty: json["delivery_accountable_party"],
    qualityRegime: json["quality_regime"],
    qualityControlMethod: json["quality_control_method"],
    gmwBroId: json["gmw_bro_id"],
    tubeNumber: json["tube_number"],
    samplingDatetime:
      json["sampling_datetime"] == null ? null : new Date(json["sampling_datetime"]),
    samplingStandard: json["sampling_standard"],
    primaryColour: json["primary_colour"],
    secondaryColour: json["secondary_colour"],
    colourStrength: json["colour_strength"],
    pumpType: json["pump_type"],
    abnormalityInCooling: json["abnormality_in_cooling"],
    abnormalityInDevice: json["abnormality_in_device"],
    pollutedByEngine: json["polluted_by_engine"],
    filterAerated: json["filter_aerated"],
    groundwaterLevelDroppedTooMuch: json["groundwater_level_dropped_too_much"],
    abnormalFilter: json["abnormal_filter"],
    sampleAerated: json["sample_aerated"],
    hoseReused: json["hose_reused"],
    temperatureDifficultToMeasure: json["temperature_difficult_to_measure"],
    labAnalysisDate: json["lab_analysis_date"] == null ? null : new Date(json["lab_analysis_date"]),
    dataOwner: json["data_owner"],
    monitoringTube: json["monitoring_tube"],
  };
}

export function GARToJSON(json: any): GAR {
  return GARToJSONTyped(json, false);
}

export function GARToJSONTyped(
  value?: Omit<GAR, "uuid" | "gmw_nitg_code" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    bro_id: value["broId"],
    delivery_accountable_party: value["deliveryAccountableParty"],
    quality_regime: value["qualityRegime"],
    quality_control_method: value["qualityControlMethod"],
    gmw_bro_id: value["gmwBroId"],
    tube_number: value["tubeNumber"],
    sampling_datetime:
      value["samplingDatetime"] == null
        ? value["samplingDatetime"]
        : value["samplingDatetime"].toISOString(),
    sampling_standard: value["samplingStandard"],
    primary_colour: value["primaryColour"],
    secondary_colour: value["secondaryColour"],
    colour_strength: value["colourStrength"],
    pump_type: value["pumpType"],
    abnormality_in_cooling: value["abnormalityInCooling"],
    abnormality_in_device: value["abnormalityInDevice"],
    polluted_by_engine: value["pollutedByEngine"],
    filter_aerated: value["filterAerated"],
    groundwater_level_dropped_too_much: value["groundwaterLevelDroppedTooMuch"],
    abnormal_filter: value["abnormalFilter"],
    sample_aerated: value["sampleAerated"],
    hose_reused: value["hoseReused"],
    temperature_difficult_to_measure: value["temperatureDifficultToMeasure"],
    lab_analysis_date:
      value["labAnalysisDate"] == null
        ? value["labAnalysisDate"]
        : value["labAnalysisDate"].toISOString().substring(0, 10),
    data_owner: value["dataOwner"],
    monitoring_tube: value["monitoringTube"],
  };
}
